<div class="h-100 d-flex flex-column">
  <app-title [noTranslate]="true"></app-title>
  
  <!-- overflow auto seulement en mode Home -->
  <div class="flex-grow-1" 
       [style.overflow]="kioskMode ? 'hidden' : 'auto'"
       style="min-height: 0;" 
       #scrollToTop>
    <app-column-list
      [objects$]="currentAnswers$"
      [textProperty]="properyToDisplay"
      (clickObject)="onClickQuestion($event)"
      [sortAsc]="false">
    </app-column-list>
  </div>

  <div class="row mt-3">
    <div class="col">
      <app-btn
        [dataTxt]="'BACK'"
        (callback)="onClickRetour()"
        [icon]="'chevron-left'"
        [iconLocation]="'left'"
      ></app-btn>
    </div>
  </div>
</div>